import React from 'react';
import { DatePicker } from '@roger/ui-components';
import {
  formatDateToYYYYMMDD,
  parseISOToLocalDate,
  parseYYYYMMDD,
} from '../../../utils/dateUtils';
import { Question } from '../types';

interface DateQuestionProps {
  question: Question;
  value: Date | string;
  onChange: (value: Date | string) => void;
  disabled?: boolean;
}

export const DateQuestion: React.FC<DateQuestionProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  const dateValue =
    value instanceof Date
      ? value
      : value
        ? (parseYYYYMMDD(String(value)) ?? parseISOToLocalDate(String(value)))
        : undefined;

  const handleDateChange = (date: Date | undefined) => {
    if (date) {
      onChange(formatDateToYYYYMMDD(date));
    } else {
      onChange('');
    }
  };

  return (
    <div className='space-y-2'>
      <label className='text-sm font-semibold text-foreground block'>
        {question.question || question.description}
      </label>

      <DatePicker
        date={dateValue}
        onDateChange={handleDateChange}
        disabled={disabled}
        placeholder='Select date...'
        datePickerSize='default'
        className='w-full'
      />
    </div>
  );
};
